/* oxlint-disable eslint/no-unused-vars, import/no-cycle -- LINTER migration follow up */
import { createFileRoute } from "@tanstack/react-router";
import { projectListSearchSchema } from "../../../../features/projects/project-trash/project-list-search";
import { DealsListPage } from "../../../../pages/deals-list-page/deals-list-page";

export const Route = createFileRoute("/_auth/_frame/deals/")({
  validateSearch: (search) => {
    const parsed = projectListSearchSchema.parse(search);
    if (parsed.from === "tenders") {
      const { from: _from, ...rest } = parsed;
      return rest;
    }
    return parsed;
  },
  component: DealsListPage,
});
